import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { configureStore } from '../../../store'
import ErrorMessageDialog from '../../ui/components/ErrorMessageDialog'
import Loading from '../../ui/components/Loading'
import App from './App'

const store = configureStore()

export default () => (
	<Provider store={store}>
		<div>
			<Router>
				<App />
			</Router>
			<ErrorMessageDialog />
			<Loading />
		</div>
	</Provider>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Root.prod.js